<template>
  <page name='InducteeDetailsPage'>
    <x-nav slot="header">Details</x-nav>

    <div id="inductee_top">
      <img :src="'//classicalwalkoffame.org/inductees/' + inductee.ImageURL" alt="Inductee Details" />
      <div class="rightside">
        <h1>{{ inductee.InducteeName }}</h1>
        <h2><a id='detailsMusicTitle' > {{ inductee.MusicTitle }}</a></h2>
      </div>
    </div>
    
    <div class="inductee_info">
      <div>{{ inductee.InducteeType }}</div>
      <div>Inducted in {{ inductee.YearInducted }}</div>
      <div>Performed By: {{ inductee.Performer }}</div>
    </div>
    
    <div id="bio">
      <p v-html="inductee.Bio"></p>
    </div>
    
    <x-footer slot="footer">
      <div id="half_buttons">
        <button :disabled="!inductee.RadioTour" class="half_button" @click="$root.playRadioTour(inductee)"><img src="img/round_play_button.png"> Radio Tour</button>
        <picker-modal class="half_button"
        @select="change"
        :options="['Fountain', 'Plaza', 'Device']">
          <img src="img/round_play_button.png"> Play this Music
        </picker-modal>
      </div>
    </x-footer>

  </page>
</template>

<script>
export default {
  components: {
    'page': require('./Page.vue'),
    'x-nav': require('./Nav.vue'),
    'x-footer': require('./Footer.vue'),
    'inductee-item': require('./InducteeItem.vue'),
  },
  computed: {
    inductee () {
      if (this.$root.route[0] === 'InducteeDetailsPage') {
        if (this.$root.fullInductees[this.$root.route[1]]) {
          return this.$root.fullInductees[this.$root.route[1]]
        } else {
          this.$root.fetchFullInductee(this.$root.route[1])
          return false
        }
      }
      return false
    },
  },
  methods: {
    change (value) {
      value = value.toLowerCase()
      this.$root.queue({
        playlist: value,
        inductee: JSON.parse(JSON.stringify(this.inductee))
      })
    }
  }
}
</script>

<style lang="less">

#inductee_top {
  text-align: left;
  border-bottom: 1px solid #afd2ef;
  padding: 25px;
  min-height: 85px;
  overflow: hidden;
  
  .rightside {
    float: left;
    clear: none;
    display: inline-block;
    width: 160px;
    max-height: 85px;
  }
  
  img {
    float: left;
    width: 85px;
    height: auto;
    display: inline-block;
    margin: 0px 15px 10px 0px;
  }
  
  h1 {
    color: #fff;
    font-weight: bold;
    font-family: "Open Sans", arial, sans-serif;
    font-size: 1.1em !important;
    margin: 10px 0px 0px 0px;
  }
  
  h2 {
    color: #afd2ef !important;
    font-style: italic;
    font-weight: normal;
    font-family: "Open Sans", arial, sans-serif;
    font-size: .9em !important;
    margin: 0px !important;
  }
  
  h2 a {
    color: #afd2ef !important;
  }
}

.inductee_info {
  
  div {
    color: #fff;
    font-weight: 500;
    padding: 12px 0px;
    text-align: center;
    background-color: #242f3c !important;
    margin: 1px 0px;
  }
}

#bio {
  padding: 20px;
  padding-top: 0;
  
  p {
    color: #fff;
  }
}

#half_buttons {
  width: 100%;
  height: 60px;
  
  img {
    width: 24px;
    display: inline-block;
    vertical-align: middle;
  }
  
  button {
    border: none;
    background: none;
  }
  
  .half_button {
    position: absolute;
    width: 50%;
    background: url(img/bottom_button.png) repeat-x top left;
    text-align: center;
    font-weight: bold;
    font-family: "myriad-pro", arial, sans-serif;
    color: #fff;
    padding: 17px 0px;
    border-bottom: 1px solid #444950;
    border-top: 1px solid #444950;
    font-size: 13px;
    &:active {
      background-color: #232c37;
      background-image: none;
    }
    &:disabled {
      background-color: white;
      color: grey;
      img {
        filter: brightness(0.5);
      }
    }
    &:first-child {
      left: 0;
      border-right: 1px solid #444950;
    }
  }
  .half_button + .half_button {
    right: 0;
  }
}
</style>
